import Model from "./Model";
import QuestionModel from "./QuestionModel";
import ArticleModel from "./ArticleModel";
import VideoModel from "./VideoModel";
import ContentModel from './ContentModel';
import ListModel from './ListModel';

export default class ListItemModel extends Model {
  id: number;
  questionId: number;
  articleId: number;
  videoId: number;
  position: number;
  listId: number;

  static __typename: string = "ListItem";

  constructor(listItem: any, getters: any) {
    super(getters);
    this.id = listItem.id;
    this.position = listItem.position;
    this.questionId = listItem.questionByQuestionId || listItem.questionId;
    this.articleId = listItem.articleByArticleId || listItem.articleId;
    this.videoId = listItem.videoByVideoId || listItem.videoId;
    this.listId = listItem.listByListId || listItem.listId;
  }

  list(): ListModel {
    return this.getters.listById(this.listId);
  }

  question(): QuestionModel {
    return this.getters.questionById(this.questionId);
  }

  article(): ArticleModel {
    return this.getters.articleById(this.articleId);
  }

  video(): VideoModel {
    return this.getters.videoById(this.videoId);
  }

  type(): string {
    if (this.questionId) {
      return QuestionModel.__typename
    } if (this.articleId) {
      return ArticleModel.__typename
    } if (this.videoId) {
      return VideoModel.__typename
    }
  }

  contents(): any {
    if (this.questionId) {
      return this.question().contents();
    } if (this.articleId) {
      return this.article().contents();
    } if(this.videoId) {
      return this.video().contents();
    }
  }

  raw() {
    return {
      id: this.id,
      questionId: this.questionId,
      articleId: this.articleId,
      listId: this.listId,
      position: this.position,
      __typename: ListItemModel.__typename
    }
  }
}